export default "__VITE_ASSET__CuAJP2KE__"